import {Box, Paper, Typography} from "@mui/material";
import Iconify from "../../components/Iconify";
import {ICONS_NAME} from "../../constants/icons";
import {styled} from "@mui/material/styles";

export const SupportContact = () => (
    <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Paper
            elevation={1}
            sx={{
                py: 1,
                px: 2,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1.5,
                borderRadius: '9999px',
                backgroundColor: '#f3f4f6', // Tailwind gray-100
            }}
        >
            <Iconify icon={ICONS_NAME.support} fontSize="small" sx={{ color: '#4b5563' }} />
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
                Potrebna vam je pomoć? Pozovite nas: <Box component="strong" sx={{ color: '#1f2937' }}>011/4444-588</Box>
            </Typography>
            <GreenDot>
                <span />
                <span />
            </GreenDot>
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1f2937' }}>
                24/7
            </Typography>
        </Paper>
    </Box>
);

const GreenDot = styled('span')({
    width: '12px',
    height: '12px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > span:nth-of-type(1)': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        backgroundColor: 'rgb(74, 222, 128)', // Tailwind green-400
        opacity: 0.75,
        animation: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
    },
    '& > span:nth-of-type(2)': {
        position: 'relative',
        display: 'inline-flex',
        borderRadius: '50%',
        height: '10px',
        width: '10px',
        backgroundColor: 'rgb(34, 197, 94)', // Tailwind green-500
    },
});
